import { types } from "./types";

const initialState = {
  // organizationId: null,
  // organizations: [],
  usersData: [],
  // organizationIdCategories : [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SELECTED_ORGANIZATION_ID':
      return {
        ...state,
        organizationId: action.payload
      };
    case types.SET_ORGANIZATIONS.SUCCESS:
      return {
        ...state,
        organizations: action.payload
      };
    case types.CREATE_ORGANIZATION.SUCCESS:
      return {
        ...state,
        organizations: [action.payload, ...state.organizations]
      };
    case types.DELETE_ORGANIZATION.SUCCESS:
      return {
        ...state,
        organizations: state.organizations?.filter(
          o => o._id !== action.payload._id
        )
      };
    case types.SET_USERS_DATA.SUCCESS:
      return {
        ...state,
        usersData: action.payload,
      };
    case types.UPDATE_ORG_INT_CATEGORIES.SUCCESS:
      return {
        ...state,
        organizationIdCategories: action.payload,
      }
    case types.RESET_ORGANIZATIONS.SUCCESS:
      return {
        ...state,
        organizations: []
      };
    default:
      return state;
  }
}

export default reducer;
